import * as yup from "yup"

export const bankValidationSchema = yup.object().shape({ 
    branch: yup.string().label("Branch").optional().max(200, "Must be 200 characters or less"),
    account_number: yup.string().label("Bank Account").optional().max(40, "Must be 40 characters or less"),
    account_name: yup.string().label("Bank Name").optional().max(200, "Must be 200 characters or less"),

    bank_id: yup.number().optional().nullable(),
})